<template>
  <Customer :id="id" />
</template>

<script>
import Customer from '../components/Customer'
export default {
    name: 'CustomerPage',
    components: {
        Customer
    },
    props: {
        id: {
            type: String,
            required: true,
        }
    }
}
</script>